// eslint-disable-next-line no-restricted-imports
import { Pressable as RNPressable, View } from "react-native";

import type { Device } from "$modules/expo-tv-connect-remote";
import Icon from "$src/core/components/atoms/Icon";
import Text from "$src/core/components/atoms/Text/Text";
import TvBrandLogo from "$src/core/components/atoms/TvBrandLogo/TvBrandLogo";
import useTranslation from "$src/core/hooks/use-translation";

import $ from "./TvConnectDeviceCard.styles";

type Props = {
  device: Device;
  onDisconnect: () => void;
};

const TvConnectDeviceCard = ({ device, onDisconnect }: Props) => {
  const { t } = useTranslation();

  return (
    <View style={$.card}>
      <View style={$.body}>
        <View style={$.brandRow}>
          <TvBrandLogo device={device} />
        </View>

        <Text
          accessibilityRole="text"
          preset="heading5"
          numberOfLines={2}
          style={$.deviceName}
        >
          {device.name}
        </Text>

        <View style={$.connectedRow}>
          <View style={$.connectedDot} />
          <Text accessibilityRole="text" preset="tiny" style={$.connectedLabel}>
            {t("TV_CONNECT/STATUS/CONNECTED")}
          </Text>
        </View>
      </View>

      <RNPressable
        onPress={onDisconnect}
        accessibilityRole="button"
        accessibilityLabel={t("TV_CONNECT/DISCOVERY/DISCONNECT")}
        style={({ pressed }) => [
          $.disconnectButton,
          pressed && $.disconnectPressed,
        ]}
      >
        <Icon name="disconnect" style={$.disconnectIcon} />
      </RNPressable>
    </View>
  );
};

export default TvConnectDeviceCard;
